<template>
  <div style="display:flex; width: auto; margin-right: 25px; font-size: 10px;">
    <p style="margin: 0px;">チーム</p>
    <v-autocomplete
      v-model="teamId"
      :items="teamList"
      @change="handleTeamChange"
      class="small-control"
      style="min-width: 190px; max-width: 190px;"
      item-text="name"
      item-value="id"
      hide-details="true"
      placeholder="選択してください"
      no-data-text="チームが見つかりません。"
      dense
      filled
    />
  </div>
</template>

<script>
export default {
  name: 'TeamSelect',
  props: {
    teamList: {
      type: Array,
      required: false,
      default: () => [],
    },
    defaultTeamId: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  data() {
    return {
      teamId: this.defaultTeamId,
    };
  },
  methods: {
    handleTeamChange(newTeamId) {
      this.$nextTick(() => {
        // 元に戻す
        this.teamId = this.defaultTeamId;
        this.$emit('teamChange', newTeamId);
      });
    },
  },
}
</script>

<style scoped>
p {
  display: flex;
  align-items: center;
  padding-right: 12px;
  margin: 0px;
}
</style>
